/* @flow */

export const RES_DISABLED_KEY = 'RES.disabled';
export const LAST_SELECTED_ENTRY_KEY = 'RES.lastSelectedEntry';



// WEBPACK FOOTER //
// ./lib/constants/sessionStorage.js